import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/home';
import useScrollReveal from '@/hooks/useScrollReveal';

const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string; hoverBorder: string }> = {
  primary: {
    bg: 'bg-primary-50 hover:bg-primary-100',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    hoverBorder: 'hover:border-primary-200',
  },
  accent: {
    bg: 'bg-accent-50 hover:bg-accent-100',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    hoverBorder: 'hover:border-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-50 hover:bg-secondary-100',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    hoverBorder: 'hover:border-secondary-200',
  },
};

export default function CategoryGrid() {
  const { t } = useTranslation();
  const revealRef = useScrollReveal();

  return (
    <section ref={revealRef} className="reveal bg-background-100 py-16 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8 text-center">
          {t('section.categories')}
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} ${colors.hoverBorder} border border-transparent rounded-xl p-6 md:p-8 flex flex-col items-center text-center cursor-pointer transition-all duration-300 hover:scale-[1.02]`}
              >
                <div className={`w-16 h-16 ${colors.iconBg} rounded-2xl flex items-center justify-center mb-4`}>
                  <i className={`${cat.icon} ${colors.iconColor} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}